/**
 * Olive.III — Luxury Footer JavaScript
 * - Accessible mobile accordions with ARIA states
 * - Keyboard navigation (Enter / Space)
 * - Shopify theme customizer live reload event bindings
 */

(function () {
  'use strict';

  function initLuxuryFooter(section) {
    if (!section || section.hasAttribute('data-footer-initialized')) return;
    section.setAttribute('data-footer-initialized', 'true');

    var accordionBtns = section.querySelectorAll('.luxury-footer__accordion-btn');

    accordionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.innerWidth >= 750) return; // Only active on mobile

        var isExpanded = btn.getAttribute('aria-expanded') === 'true';
        var controlsId = btn.getAttribute('aria-controls');
        var targetWrap = controlsId ? document.getElementById(controlsId) : null;

        if (!targetWrap) return;

        if (isExpanded) {
          btn.setAttribute('aria-expanded', 'false');
          targetWrap.classList.remove('is-open');
        } else {
          // Optional accordion behavior: close other open menus on mobile
          accordionBtns.forEach(function (otherBtn) {
            if (otherBtn !== btn) {
              otherBtn.setAttribute('aria-expanded', 'false');
              var otherId = otherBtn.getAttribute('aria-controls');
              var otherWrap = otherId ? document.getElementById(otherId) : null;
              if (otherWrap) {
                otherWrap.classList.remove('is-open');
              }
            }
          });

          btn.setAttribute('aria-expanded', 'true');
          targetWrap.classList.add('is-open');
        }
      });

      // Handle keyboard accessibility (Enter / Space)
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          btn.click();
        }
      });
    });

    // Reset accordion classes if screen is resized back to desktop
    window.addEventListener('resize', function () {
      if (window.innerWidth >= 750) {
        accordionBtns.forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
          var controlsId = btn.getAttribute('aria-controls');
          var targetWrap = controlsId ? document.getElementById(controlsId) : null;
          if (targetWrap) {
            targetWrap.classList.remove('is-open');
          }
        });
      }
    });
  }

  function initAllFooters() {
    var footerSections = document.querySelectorAll('.luxury-footer');
    footerSections.forEach(function (footer) {
      initLuxuryFooter(footer);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllFooters);
  } else {
    initAllFooters();
  }

  // Shopify theme editor integration
  document.addEventListener('shopify:section:load', function (event) {
    var footer = event.target.querySelector('.luxury-footer') || (event.target.classList.contains('luxury-footer') ? event.target : null);
    if (footer) {
      footer.removeAttribute('data-footer-initialized');
      initLuxuryFooter(footer);
    }
  });
})();
